import React from "react";
import TableFilter from "./TableFilter";
import TableSort from "./TableSort";
import { classNames } from "../../../helpers/classNames";
import Checkbox from "../../form/Checkbox";
import PopoverDropdown from "../PopoverDropdown";

const Th = ({
  thClass,
  name,
  nameAlign,
  isSort,
  isFilter,
  isFilterSearch,
  content,
  filterDropdown,
  type,
  onSort = () => {},
  onFilter = () => {},
  filterSearch = () => {},
  onFilterScroll = () => {},
  handleCheckboxChange,
  onCheckboxChange,
  checkboxChecked,
  ...props
}) => {
  const align = {
    left: "justify-start",
    right: "justify-end",
    center: "justify-center",
    "": "justify-start",
  };

  return (
    <>
      <th
        className={classNames(
          "py-4 px-2 text-left min-w-[120px] max-w-[240px] border-none bg-surface-04 first:rounded-tl-md last:rounded-tr-md border-secondary first:border-l last:border-r",
          "last:right-0",
          thClass
        )}
      >
        <div
          className={classNames(
            "flex items-center gap-1 w-full",
            align[nameAlign]
          )}
        >
          {name && (
            <div className="text-xs uppercase font-semibold text-deep-purple">
              {name}
            </div>
          )}
          {type === "checkbox" && (
            <Checkbox checked={checkboxChecked} onChange={onCheckboxChange} />
          )}
          {(isSort || isFilter) && (
            <div className="flex justify-end items-center flex-shrink-0">
              {isSort && <TableSort sortState={"nostate"} onSort={onSort} />}
              {isFilter &&
                (React.isValidElement(content) ? (
                  <PopoverDropdown
                    buttonLabel={
                      <i className="fa-solid fa-fw fa-filter-list text-deep-purple"></i>
                    }
                    buttonClass="bg-transparent w-5 h-5 !p-0"
                  >
                    {content}
                  </PopoverDropdown>
                ) : (
                  <TableFilter
                    xPlacement="bottomRight"
                    filterData={filterDropdown}
                    isFilterSearch={isFilterSearch}
                    onScroll={onFilterScroll}
                    filterSearch={filterSearch}
                    onFilter={onFilter}
                  />
                ))}
            </div>
          )}
        </div>
      </th>
    </>
  );
};

export default Th;
